import { Grid, IconButton } from '@mui/material'
import { Delete, Preview } from '@mui/icons-material'
import PropTypes from 'prop-types'
import Confirmation from '../../popups/Confirmation'
import { useState } from 'react'
import axios from 'axios'
import { handleOpenAlert } from '../../../../lib/handleAlert'
import { refreshFilter } from '../../../../lib/handleFilters'
import { useDispatch } from 'react-redux'
import { openPopup } from '../../../../store/popupsSlice'

const PatientNotesTableActions = ({ row }) => {
  const [confirmation, setConfirmation] = useState(false)
  const dispatch = useDispatch()

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="row"
      spacing={1}
      className="table-actions"
    >
      {confirmation && (
        <Confirmation
          level={5}
          maxWidth="xs"
          icon="Warning"
          title={`Czy na pewno chcesz usunąć notatkę?`}
          subtitle={`Ta operacja nie jest odwracalna.`}
          reject={() => {
            setConfirmation(false)
          }}
          success={() => {
            axios
              .delete(`/patients/${row.patient_id}/notes/${row.id}`)
              .then(() => {
                handleOpenAlert({
                  title: 'Sukces!',
                  subtitle: `${
                    row.active == 0 ? 'Przywrócono' : 'Usunięto'
                  } notatkę`,
                  type: 'success',
                })
                refreshFilter('PatientNotesKey')
              })
              .finally(() => {
                setConfirmation(false)
              })
          }}
        />
      )}
      <Grid>
        <IconButton
          title="Podgląd notatki"
          size="small"
          onClick={() =>
            dispatch(
              openPopup({
                component: 'PatientNotePreview',
                title: `Podgląd notatki: ${row.name}`,
                level: 1,
                maxWidth: 'xl',
                key: 'patient-note-preview-popup',
                values: {
                  patient_id: row.patient_id,
                  id: row.id,
                },
              })
            )
          }
        >
          <Preview fontSize="small" />
        </IconButton>
        <IconButton
          title="Usuń notatkę"
          size="small"
          onClick={() => setConfirmation(true)}
        >
          <Delete fontSize="small" color="error" />
        </IconButton>
      </Grid>
    </Grid>
  )
}

PatientNotesTableActions.propTypes = {
  row: PropTypes.object,
}

export default PatientNotesTableActions
